 <!--
    2019-2-13, AJK, created file
    2019-3-6, AJK, added ability to reset password
    2019-3-6, AJK, updated to use snotify
 -->

<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class="columns is-centered">
      <div id="card" class="column card-container is-full">
        <h1 class="title">Thank you!</h1>
        <p>Card was captured successfully. Please go back to FileMaker screen.</p>
      </div>
    </div>
  </div>
</template>

<script>
import loginAPI from "@/api/LoginAPI.js";
import sharedAPI from "@/api/SharedAPI.js";
import store from "../store.js";
import { mapMutations, mapState } from "vuex";
import axios from "axios";

export default {
  name: "ThankYou",
  props: ["usernameProp"],
  data() {
    return {
    };
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.has-text-danger {
  padding-bottom: 20px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.card-container {
  padding: 2rem;
  margin: 0px 20px 20px 20px;
}
/*.field-container {*/
/*  background-color: #FFFFFF;*/
/*  border: solid 1px #cccccc;*/
/*  border-radius: 5px;*/
/*  padding: 2rem;*/
/*  margin: 0px 20px 20px 20px;*/
/*}  */
</style>
